export const translationJA = {
  top: {
    text_1: '新鮮な食材とより良い地球',
    text_2: 'AIがお勧めする',
    text_3: '数千のレシピ',
    text_4: '食材を管理するのを助ける場所',
    text_5: 'さまざまな料理のレシピ、',
    text_6: '週ごとのメニュー、買い物リスト',
  },
  main_function: {
    text_1: '主な機能',
    text_1_1: '食材を新鮮に保つ！',
    text_1_2: 'フレッシュネスチェッカーからの通知を受け取り、食材を無駄にしないようにします',
    text_2_1: 'AI レシピ提案',
    text_2_2: '冷蔵庫に残った食材に基づいて、世界中のさまざまな料理のレシピを発見します',
    text_3_1: '1週間分のメニュー',
    text_3_2: '1週間分のメニューを作成します',
    text_4_1: '買い物リスト',
    text_4_2: '買い物の準備のために買い物リストを作成し、更新します',
    text_5: 'ダウンロード',
    text_6: 'iFridge があなたを助けます',
    text_7_1: 'より良い家庭人になる',
    text_7_2: '廃棄物を削減し、健康的な地球を作る',
    text_7_3: '料理を楽しむ',
  },
  rate_box: {
    text_1: '利用者からの評価',
  },
  faqs: {
    text_1: 'よくある質問',
    text_2_1: 'アカウントにはどのような種類がありますか？無料でアプリを使用できますか？',
    text_2_2: `最初の1か月間は、アプリのすべての機能を無料で広告なしで利用できます。
      <br /><br />最初の1か月が終了すると、アカウントは自動的に無料アカウントに切り替わります。
      <br /><br />無料アカウントでは、食材管理、毎日の食材状態レポートなど、アプリの基本機能を利用できます。ただし、AI レシピ提案、週ごとのメニュー、買い物リストなどの高度な機能は利用できません。アプリを使用する際に広告が表示されます。
      <br /><br />すべての機能を広告なしで利用するには、非常に手頃な月額料金でプレミアムアカウントにアップグレードする必要があります。`,
    text_3_1: 'プレミアムアカウントの料金はいくらですか？',
    text_3_2: `月額または年額でサブスクリプションを購入できます。
      <br /><br />月額料金: $0.99/月。
      <br /><br />年額料金: $9.99/年。
      <br /><br />追加料金はありません。`,
    text_4_1: 'お金を払わずにプレミアムアカウントを登録できますか？',
    text_4_2: `もちろん可能です。
      <br /><br />プレミアムアカウントを登録するには、iFridge ポイントを使用します。
      <br /><br />iFridge ポイントは、設定画面の「ポイント」メニューでアプリストア/Google Playを通じて購入できます。
      <br /><br />または、広告を視聴して iFridge ポイントを獲得できます: 設定画面の「その他の設定」メニューで広告を視聴します。`,
    text_5_1: '広告を視聴することで iFridge ポイントを獲得できますか？',
    text_5_2: `広告を視聴することで iFridge ポイントを獲得できます。
      <br /><br />あなたの国によって、各広告視聴ごとに一定数の iFridge ポイントを獲得できます（Google Admob 規定による）。広告を1回視聴した後、次の広告を視聴するには20分待つ必要があります。`,
    text_6_1: '友達を紹介して iFridge ポイントを獲得できますか？',
    text_6_2: `もちろん可能です。
      <br /><br />Facebook、Twitterなどのソーシャルネットワークで iFridge 情報を共有することで、一定数の iFridge ポイントを獲得できます。
      <br /><br />1か月に1回、友達紹介に対して iFridge ポイントを獲得できます。`,
    text_7_1: '私の個人データは安全に保管されていますか？第三者と共有されていますか？',
    text_7_2:
      'あなたのデータは完全にあなたの携帯電話に保存され、安全に保管されています。私たちはあなたの個人データをサーバーに保存したり、第三者と共有したりしません。',
    text_8_1: 'サポートが必要な場合は、どうすれば連絡できますか？',
    text_8_2: `設定画面の「その他の設定」メニューから「お問い合わせ」を選択することで、私たちに連絡できます。
      <br /><br />または、以下のメールアドレスに直接サポート依頼/フィードバックを送信してください: ifridge.foodie@gmail.com`,
  },
  footer: {
    text_1: '愛は訪れたり去ったりしますが、',
    text_2: '空腹は毎日訪れます',
  },
};
